import { useState } from "react";

const useDebounce = (callback, delay) => {
  const [debounceTimer, setDebounceTimer] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const handleDebounce = (e) => {
    setDebouncedValue(e.target.value);
    if (debounceTimer) clearTimeout(debounceTimer);

    setDebounceTimer(
      setTimeout(() => {
        callback(e.target.value.trim());
      }, delay)
    );
  };

  return [debouncedValue, handleDebounce];
};

export default useDebounce;